module.exports = {
  ctx: [
    [/^\/search(?:\?|\/|$)/, '/search/[[...option]]'],
    [/^\/search[^?/]/, '/search[INVALID_URL]'],
  ],
};
